import { Boxes, Component, Car, Crosshair, Blocks, Gamepad2 } from "lucide-react";

export const ENGINES = {
  ue5: {
    label: "Unreal Engine 5", short: "UE5", icon: Boxes, accent: "text-nc-blue border-nc-blue/40 bg-nc-blue/10",
    categories: ["Blueprints", "C++ Source", "Maps / Levels", "Assets & Textures", "Animations", "Config"],
    versions: ["5.3", "5.4", "5.5", "5.6"], frameworks: [],
  },
  unity: {
    label: "Unity", short: "UNITY", icon: Component, accent: "text-zinc-300 border-white/25 bg-white/5",
    categories: ["C# Scripts", "Scenes", "Prefabs", "Shaders", "Packages"],
    versions: ["2022 LTS", "2023", "Unity 6"], frameworks: [],
  },
  fivem: {
    label: "FiveM (GTA V)", short: "FIVEM", icon: Car, accent: "text-nc-orange border-nc-orange/40 bg-nc-orange/10",
    categories: ["Lua Scripts", "Resources", "MLO / Maps", "Vehicles", "EUP / Clothing", "Models / YFT", "Textures / YTD", "Maps / YMAP", "Server Config"],
    versions: ["b2944", "b3095", "b3258", "b3407"], frameworks: ["ESX", "QB-Core", "Ox Lib", "Standalone", "RAGE MP", "alt:V", "Single Player"],
  },
  arma: {
    label: "Arma Reforger", short: "REFORGER", icon: Crosshair, accent: "text-nc-green border-nc-green/40 bg-nc-green/10",
    categories: ["Enforce Scripts", "Addons / PBO", "Terrains", "Vehicles", "Configs"],
    versions: ["1.1", "1.2", "1.3"], frameworks: [],
  },
  minecraft: {
    label: "Minecraft", short: "MINECRAFT", icon: Blocks, accent: "text-emerald-400 border-emerald-400/40 bg-emerald-400/10",
    categories: ["Plugins (Jar)", "Mods", "Datapacks", "Worlds", "Configs"],
    versions: ["1.20.2", "1.20.4", "1.21", "1.21.4"], frameworks: ["Paper", "Spigot", "Fabric", "Forge"],
  },
  custom: {
    label: "Other / Custom Game", short: "CUSTOM", icon: Gamepad2, accent: "text-fuchsia-400 border-fuchsia-400/40 bg-fuchsia-400/10",
    categories: ["Scripts / Plugins", "Maps / Levels", "Models / Assets", "Server Config", "Tools"],
    versions: ["Any"], frameworks: [],
  },
};

export const MODDING_ENGINES = ["fivem", "arma", "minecraft", "custom"];
export const PROJECT_TYPES = ["Mod", "Tool", "Full App", "Map / Level"];
export const DIFFICULTIES = ["Easy", "Moderate", "Advanced", "Expert"];
export const CLEARANCE_LABELS = { 1: "RECRUIT", 2: "CLEARED", 3: "VETERAN", 4: "SPECIALIST", 5: "ELITE" };
export const CLEARANCE_COLORS = {
  1: "text-zinc-400 border-white/20 bg-white/5",
  2: "text-nc-blue border-nc-blue/40 bg-nc-blue/10",
  3: "text-nc-green border-nc-green/40 bg-nc-green/10",
  4: "text-nc-orange border-nc-orange/40 bg-nc-orange/10",
  5: "text-yellow-400 border-yellow-400/40 bg-yellow-400/10",
};
